/**
 * @file       Deliberations mixin, used by the whole deliberations module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

/**
 * Deliberations mixin.
 *
 * @type  {Object}
 */
const dlibrsMixin = {
  data() {
    return {
      dataLastConnection: [],
      titleLastConnection: ""
    };
  },
  computed: {
    ...mapState({
      profile: state =>
        state.auth.profile.data ? state.auth.profile.data.data.find(u => u) : {}
    }),
    isTeacher() {
      return this.profile.role === "teacher";
    },
    isStudent() {
      return this.profile.role === "student";
    }
  },
  methods: {
    /**
     * Show last connection.
     *
     * @param   {Object}  data     The data
     */
    showLastConnection(data) {
      if (data.data.length) {
        this.dataLastConnection = data.data;
        this.titleLastConnection = data.title;
        this.$store
          .dispatch("deliberations/getDlibr", {
            params: { id: data.id }
          })
          .then(() => {
            this.$root.$emit("bv::show::modal", "lastConnectionModal");
          });
      }
    },

    /**
     * Go to flagged.
     *
     * @param   {Object}  dlibr     The deliberation
     */
    goToFlagged(dlibr) {
      let query = this.isStudent
        ? { user: this.profile.id, deliberation: dlibr.id, flagged: 1 }
        : { deliberation: dlibr.id, flagged: 1 };
      this.$router.replace({
        query: query
      });
      this.$router.push({
        name: "deliberation.byUrl",
        params: {
          teacher: dlibr.teacher,
          url: dlibr.url
        }
      });
    }
  }
};

export { dlibrsMixin };
